exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**\n  Project Colors\n */\n/**\nWebsites SCSS\n */\n.web-templates {\n  max-width: 120em;\n  display: -ms-flexbox;\n  display: flex;\n  margin: 0 auto;\n  padding-left: .7em;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: center;\n      justify-content: center; }\n\n.page-title {\n  color: #111111;\n  background-color: #DFD000; }\n\n:host {\n  display: block;\n  color: #9d9d9d; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/websites/websites.component.scss
// module id = 393
// module chunks = 1